/* =====================================================================
   mmo457 · Brickmode Lab — Verhalten der eigenen Bausteine
   1. Einblenden beim Hereinscrollen (einmalig, respektiert reduced-motion)
   2. Lieferzeitfenster (Annahmeschluss → Versand nächster Werktag → DHL-Laufzeit)
   3. Mobile Kaufleiste auf der Produktseite
   Die Scroll-Bühne hat ihre eigene Datei (mmo-scrollhero.js), die nur auf Seiten
   mit dieser Section geladen wird.
   ===================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  root.classList.add('mmo-js');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Einblenden ---------- */
  var revealSelector = '.mmo-reveal, .mmo-eyebrow';
  var observer = null;

  function markVisible(el) {
    el.classList.add('is-visible');
  }

  function observeReveals(scope) {
    var nodes = (scope || document).querySelectorAll(revealSelector);
    if (!nodes.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(markVisible);
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              markVisible(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
    }
    nodes.forEach(function (el) {
      if (!el.classList.contains('is-visible')) observer.observe(el);
    });
  }

  /* ---------- 2. Lieferzeitfenster ---------- */

  // Bundesweite Feiertage plus die in Nordrhein-Westfalen (Versandort), je Jahr gerechnet.
  function easterSunday(year) {
    var a = year % 19, b = Math.floor(year / 100), c = year % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(year, month - 1, day));
  }

  function addDaysUTC(date, days) {
    var d = new Date(date.getTime());
    d.setUTCDate(d.getUTCDate() + days);
    return d;
  }

  function keyOf(date) {
    return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate());
  }

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function holidaysFor(year) {
    var easter = easterSunday(year);
    var list = [
      new Date(Date.UTC(year, 0, 1)), // Neujahr
      addDaysUTC(easter, -2), // Karfreitag
      addDaysUTC(easter, 1), // Ostermontag
      new Date(Date.UTC(year, 4, 1)), // Tag der Arbeit
      addDaysUTC(easter, 39), // Christi Himmelfahrt
      addDaysUTC(easter, 50), // Pfingstmontag
      addDaysUTC(easter, 60), // Fronleichnam (NRW)
      new Date(Date.UTC(year, 9, 3)), // Tag der Deutschen Einheit
      new Date(Date.UTC(year, 10, 1)), // Allerheiligen (NRW)
      new Date(Date.UTC(year, 11, 25)), // 1. Weihnachtstag
      new Date(Date.UTC(year, 11, 26)) // 2. Weihnachtstag
    ];
    return list.map(keyOf);
  }

  // "Jetzt" in deutscher Zeit, unabhängig von der Zeitzone des Besuchers.
  function berlinNow() {
    var parts;
    try {
      var fmt = new Intl.DateTimeFormat('de-DE', {
        timeZone: 'Europe/Berlin',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      });
      parts = {};
      fmt.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      return {
        date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)),
        minutes: (+parts.hour % 24) * 60 + (+parts.minute)
      };
    } catch (e) {
      var n = new Date();
      return { date: new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())), minutes: n.getHours() * 60 + n.getMinutes() };
    }
  }

  function isWorkday(date, extra) {
    var dow = date.getUTCDay();
    if (dow === 0 || dow === 6) return false;
    var k = keyOf(date);
    if (extra.indexOf(k) !== -1) return false;
    return holidaysFor(date.getUTCFullYear()).indexOf(k) === -1;
  }

  function nextWorkday(date, extra) {
    var d = addDaysUTC(date, 1);
    var guard = 0;
    while (!isWorkday(d, extra) && guard++ < 30) d = addDaysUTC(d, 1);
    return d;
  }

  function addWorkdays(date, count, extra) {
    var d = date;
    for (var i = 0; i < count; i++) d = nextWorkday(d, extra);
    return d;
  }

  var weekdayNames = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  function formatShort(date) {
    return weekdayNames[date.getUTCDay()] + ', ' + pad(date.getUTCDate()) + '.' + pad(date.getUTCMonth() + 1) + '.';
  }

  function parseCutoff(str) {
    var m = /^(\d{1,2}):(\d{2})$/.exec((str || '').trim());
    if (!m) return 18 * 60;
    return (+m[1]) * 60 + (+m[2]);
  }

  function renderLieferzeit(el) {
    if (el.dataset.mmoDone === '1') return;
    var cutoffMin = parseCutoff(el.dataset.cutoff);
    var processing = Math.max(0, parseInt(el.dataset.processing || '1', 10) || 0);
    var tMin = Math.max(0, parseInt(el.dataset.transitMin || '2', 10) || 0);
    var tMax = Math.max(tMin, parseInt(el.dataset.transitMax || '3', 10) || tMin);
    var extra = (el.dataset.holidays || '')
      .split(/[,\s]+/)
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return /^\d{4}-\d{2}-\d{2}$/.test(s); });

    var now = berlinNow();
    var beforeCutoff = now.minutes < cutoffMin;
    var orderDay = beforeCutoff ? now.date : addDaysUTC(now.date, 1);

    // Versand: "processing" Werktage nach dem Bestelltag (1 = am nächsten Werktag)
    var shipDay = processing === 0 ? (isWorkday(orderDay, extra) ? orderDay : nextWorkday(orderDay, extra)) : addWorkdays(orderDay, processing, extra);
    var from = addWorkdays(shipDay, tMin, extra);
    var to = addWorkdays(shipDay, tMax, extra);

    var cutoffText = pad(Math.floor(cutoffMin / 60)) + ':' + pad(cutoffMin % 60);
    var lead = beforeCutoff
      ? (el.dataset.textBefore || 'Heute bis {cutoff} Uhr bestellt').replace('{cutoff}', cutoffText)
      : (el.dataset.textAfter || 'Jetzt bestellt');
    var window_ = formatShort(from) + (tMax > tMin ? ' – ' + formatShort(to) : '');
    var main = (el.dataset.textWindow || 'Zustellung voraussichtlich {window}').replace('{window}', window_);
    var sub = (el.dataset.textSub || 'Versand am {ship}, DHL-Laufzeit {min}–{max} Werktage')
      .replace('{ship}', formatShort(shipDay))
      .replace('{min}', String(tMin))
      .replace('{max}', String(tMax));

    var leadEl = el.querySelector('[data-part="lead"]');
    var mainEl = el.querySelector('[data-part="main"]');
    var subEl = el.querySelector('[data-part="sub"]');
    if (leadEl) leadEl.textContent = lead;
    if (mainEl) mainEl.textContent = main;
    if (subEl) subEl.textContent = sub;
    el.dataset.mmoDone = '1';
    el.removeAttribute('hidden');
  }

  function renderAllLieferzeit(scope) {
    (scope || document).querySelectorAll('[data-mmo-lieferzeit]').forEach(renderLieferzeit);
  }

  /* ---------- 3. Mobile Kaufleiste ---------- */
  function setupStickyBar() {
    var main = document.getElementById('MainContent');
    if (!main || !/product/.test(main.dataset.template || '')) return;
    if (document.querySelector('.mmo-stickybar')) return;
    var form = document.querySelector('product-form-component form, form[data-type="add-to-cart-form"], .product-form');
    var button = document.querySelector('.add-to-cart-button, button[name="add"]');
    if (!button) return;

    var priceEl = document.querySelector('product-price .price, .price-item__group.price .price, .price');
    var titleEl = document.querySelector('h1');

    var bar = document.createElement('div');
    bar.className = 'mmo-stickybar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="mmo-stickybar__price"><strong></strong><span></span></div>' +
      '<button type="button" class="button mmo-stickybar__button"></button>';
    document.body.appendChild(bar);

    var priceOut = bar.querySelector('strong');
    var titleOut = bar.querySelector('span');
    var proxy = bar.querySelector('button');

    function sync() {
      priceOut.textContent = priceEl ? priceEl.textContent.trim() : '';
      titleOut.textContent = titleEl ? titleEl.textContent.trim() : '';
      proxy.textContent = (button.textContent || 'In den Warenkorb').trim();
      proxy.disabled = button.disabled;
    }
    sync();

    proxy.addEventListener('click', function () {
      button.focus();
      button.click();
    });

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-shown', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      },
      { threshold: 0 }
    );
    io.observe(button);

    // Preis und Zustand nachziehen, wenn Horizon die Kaufbox neu rendert (Variantenwechsel)
    if (form && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var b = document.querySelector('.add-to-cart-button, button[name="add"]');
        if (b) button = b;
        priceEl = document.querySelector('product-price .price, .price-item__group.price .price, .price');
        sync();
      }).observe(main, { subtree: true, childList: true, characterData: true });
    }
  }

  /* ---------- 4. Ausverkaufte ans Ende der Kollektion ---------- */
  // Innerhalb jedes geladenen Produktrasters (auch bei Infinite Scroll):
  // verfügbare Kacheln zuerst, ausverkaufte hinten.
  // Voraussetzung: main-collection.liquid setzt data-available auf jedes <li>.
  function sortSoldOutLast(grid) {
    var items = Array.from(grid.querySelectorAll('.product-grid__item[data-available]'));
    if (items.length < 2) return;
    var available = [];
    var sold = [];
    items.forEach(function (el) {
      if (el.dataset.available === 'true') available.push(el);
      else sold.push(el);
    });
    if (!sold.length) return; // nichts zu tun
    var frag = document.createDocumentFragment();
    available.forEach(function (el) { frag.appendChild(el); });
    sold.forEach(function (el) { frag.appendChild(el); });
    grid.appendChild(frag);
  }

  function setupSoldOutSort() {
    document.querySelectorAll('.product-grid').forEach(function (grid) {
      sortSoldOutLast(grid);
      if (!('MutationObserver' in window)) return;
      // Infinite Scroll: nach jedem neuen Batch neu sortieren
      var timer = null;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { sortSoldOutLast(grid); }, 80);
      }).observe(grid, { childList: true });
    });
  }

  /* ---------- Start ---------- */
  function init(scope) {
    observeReveals(scope);
    renderAllLieferzeit(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); setupStickyBar(); setupSoldOutSort(); });
  } else {
    init();
    setupStickyBar();
    setupSoldOutSort();
  }

  // Schublade und Abschnitte werden von Horizon nachgeladen — neue Knoten mitnehmen
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; init(); });
    }).observe(document.body, { subtree: true, childList: true });
  }

  // Theme-Editor: Abschnitt neu geladen
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
